const ParkProject = () => import(/* webpackChunkName: "parkproject" */ './Index');
// const View = () => import(/* webpackChunkName: "made-in-china-2025" */ './View');
// const ViewAll = () => import(/* webpackChunkName: "made-in-china-2025" */ './ViewALl');

export default {
  routes: [
    {
      path: '/park/project',
      name: 'parkproject_project',
      component: ParkProject,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/parkproject/v2018/router.js